import React from 'react';
import ReactTable, { SortingRule, Column } from 'react-table-6'; // react-table-6 is the legacy version of react-table
import 'react-table-6/react-table.css';

interface Props {
  columns: Column[];
  data: any[];
  multiSort?: boolean;
  defaultSorted?: SortingRule[];
  manual?: boolean;
  page?: number;
  pageSize?: number;
  totalCount?: number;
  pages?: number;
  onPageSizeChange?: (newPageSize: number, newPage: number) => void;
  onPageChange?: (page: number) => void;
  onSortedChange?: (newSorted: any, column: any, additive: boolean) => void;
}

const PAGE_SIZES: number[] = [25, 50, 75, 100, 250];
const DEFAULT_PAGE_SIZE = 25;

const TableWrapper = ({ ...props }: Props) => (
  // @ts-ignore
  <ReactTable
    data={props.data}
    columns={props.columns}
    multiSort={props.multiSort}
    defaultSorted={props.defaultSorted}
    className="table-component--first-colored-cell -striped -highlight table-component"
    manual={props.manual}
    defaultPageSize={DEFAULT_PAGE_SIZE}
    page={props.page}
    pages={props.pages}
    pageSize={props.pageSize}
    pageSizeOptions={PAGE_SIZES}
    minRows={0}
    onPageChange={props.onPageChange}
    onPageSizeChange={props.onPageSizeChange}
    onSortedChange={props.onSortedChange}
  />
);

export default TableWrapper;
